import {
  HANDLE_STORE_MODERATION,
  HANDLE_STORE_MODERATION_ERROR,
  CLEAN_HANDLE_STORE_MODERATION,
  CLEAN_HANDLE_STORE_MODERATION_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function ipbDirectoryModerationReducer(state = initialState, action) {
  switch (action.type) {
    case HANDLE_STORE_MODERATION:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case HANDLE_STORE_MODERATION_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_HANDLE_STORE_MODERATION:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_HANDLE_STORE_MODERATION_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
